import { render, staticRenderFns } from "./BranchesTableV2.vue?vue&type=template&id=0529f00c&"
import script from "./BranchesTableV2.vue?vue&type=script&lang=js&"
export * from "./BranchesTableV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports